import { useMessage } from "app/hooks";
import { memo } from "react";
import { Modal, Typography, Box, Button, IconButton } from "@mui/material";
import styled from "@emotion/styled";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { get } from "lodash";

const Styled = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ecefff;
  max-width: 550px;
  width: calc(100% - 15px);
  border-radius: 10px;
  /* width: calc(100% - 16px); */
  .modal-container {
    min-height: 290px;
    padding: 70px 50px 26px 50px;
    position: relative;
    display: flex;
    flex-direction: column;
    .modal-body {
      flex: 1;
    }

    .modal-title {
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      margin-bottom: 20px;
    }
    .button {
      border-radius: 10px;
      height: 50px;
      width: 100px;
    }
    .exit {
      position: absolute;
      top: 15px;
      right: 20px;
    }
    .go-back {
      display: flex;
      margin-top: 20px;
      align-items: center;
      gap: 10px;
      font-weight: 400;
      font-size: 16px;
      color: #0d8ceb;
      cursor: pointer;
      text-decoration: underline;
    }
  }
  @media only screen and (max-width: 1536px) {
    .button {
      font-size: 12px;
      height: 40px !important;
    }
  }
`;

const MessagePopup = () => {
  const {
    text,
    confirm,
    setMessage,
    yes = () => "",
    no = () => "",
    config = { exitIcon: true, back: true, onClose: () => "" },
  } = useMessage();
  return (
    <Modal open={!!text} onClose={() => get(config, "onClose")?.()}>
      <Styled>
        <div className="modal-container">
          {get(config, "exitIcon") && (
            <IconButton
              onClick={() => {
                get(config, "onClose")?.();
                setMessage({ text: "", type: "" });
              }}
              className="exit"
            >
              <CloseIcon />
            </IconButton>
          )}
          <div className="modal-body">
            <Typography className="modal-title" variant="h6" component="h2">
              {text}
            </Typography>
            {confirm ? (
              <Box
                display={"flex"}
                justifyContent="center"
                alignItems="center"
                gap="24px"
              >
                <Button onClick={no} className="button" variant="contained">
                  No
                </Button>
                <Button
                  onClick={yes}
                  sx={{ bgcolor: "white" }}
                  className="button"
                  variant="outlined"
                >
                  Yes
                </Button>
              </Box>
            ) : null}
          </div>
          {get(config, "back") && (
            <Box onClick={() => setMessage({})} className="go-back">
              <ArrowBackIcon />
              Go back
            </Box>
          )}
        </div>
      </Styled>
    </Modal>
  );
};

export default memo(MessagePopup);
